import { useMemo } from 'react';
import { Provider } from 'sly/providerIndex/ProviderIndex.types';
import ProviderIndexCard from 'sly/providerIndex/ProviderIndexBody/ProviderIndexCard';
import { usePrefetch } from 'sly/services/api';

export default function ProviderIndexBody() {
  const { requestInfo } = usePrefetch('getProviders');

  const providers = useMemo(() => {
    const unsortedProviders = requestInfo.normalized || [];

    if (unsortedProviders.length) {
      const filteredProviders = unsortedProviders.filter(
        (provider: Provider) => {
          return (
            provider.info.communityPartnerCollectionStats.communityCount > 0
          );
        }
      );
      return [...filteredProviders].sort((a: Provider, b: Provider) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    }

    return unsortedProviders;
  }, [requestInfo]);

  return (
    <div className='grid grid-cols-1 gap-y-4 gap-x-2 md:grid-cols-2 md:pt-l'>
      {providers.map((card: Provider) => {
        return (
          <ProviderIndexCard
            key={card.id}
            heading={card.name}
            communityCount={
              card.info.communityPartnerCollectionStats.communityCount
            }
            reviewsValue={card.info.ratingStats.reviewsValue}
            numReviews={card.info.ratingStats.numReviews}
            url={card.url}
          />
        );
      })}
    </div>
  );
}
